import { Camera } from 'lucide-react';

import { ContentPanelMode, ContextPanelMode, pushContextPanel, selectContentPanelMode, useAppSelector } from '@state';
import { Feature, FeatureHoookParams } from '..';
import { isRenderingStale } from '@helpers';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { useDispatch } from 'react-redux';

type UseRenderingPropertiesFeatureParams = FeatureHoookParams;
export const useRenderingPropertiesFeature = (_params: UseRenderingPropertiesFeatureParams = {}): Feature<null> => {
	const dispatch = useDispatch();
	const contentMode: ContentPanelMode = useAppSelector(selectContentPanelMode);
	const [, design] = useDesign();

	const [disabled, tooltip] = (() => {
		if (contentMode === ContentPanelMode.ThreeD || contentMode === ContentPanelMode.Designer) return [false, lang.view.tooltip.renderingProperties];
		return [true, lang.view.tooltip.onlyOnComponent];
	})();

	// Badge whenever a rendering is needed: none captured yet, or design edited since last capture (matches save-as-draft staleness)
	const indicator = isRenderingStale({ design });

	return {
		name: 'rendering-properties',
		label: lang.view.label.renderingProperties,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <Camera {...props} />,
		disabled,
		value: null,
		hidden: false,
		indicator,
		handler: () => {
			dispatch(pushContextPanel({ mode: ContextPanelMode.RenderingProperties }));
		}
	};
};
